export default __webpack_public_path__ + "static/P_SearchThumb_IN-9820QFHD_Downloads-68938c922b00c39d1a0771c106b9b504.webp";